var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 24.75C16.1906 24.7495 18.5609 23.9325 20.4834 22.429L26.5279 28.4735L28.4721 26.5293L22.4276 20.4847C23.9319 18.562 24.7494 16.1912 24.75 13.75C24.75 7.68488 19.8151 2.75 13.75 2.75C7.68488 2.75 2.75 7.68488 2.75 13.75C2.75 19.8151 7.68488 24.75 13.75 24.75ZM13.75 5.5C18.2999 5.5 22 9.20012 22 13.75C22 18.2999 18.2999 22 13.75 22C9.20012 22 5.5 18.2999 5.5 13.75C5.5 9.20012 9.20012 5.5 13.75 5.5Z",
    fill: "#005734"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6915 11.8057C16.2126 12.3282 16.5 13.0185 16.5 13.75H19.25C19.2512 13.0273 19.1092 12.3116 18.8321 11.6442C18.555 10.9767 18.1484 10.3708 17.6358 9.8615C15.554 7.7825 11.9446 7.7825 9.86426 9.8615L11.8058 11.8085C12.8508 10.7662 14.652 10.769 15.6915 11.8057Z",
    fill: "#005734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1933fe83aa3c36a7c70c24becfc4cd22.svg";
export { ForwardRef as ReactComponent };